module.exports = __webpack_public_path__ + "img/woman-with-basket.335e652.svg";